<template>
  <div class="system-stations">
    <page-header title="Stations">
      <div slot="sub-title">
        <i class="el-icon-news" />
        Stations management
      </div>
      <div slot="controls">
        <el-button type="primary" class="add-organization-button white-button" icon="el-icon-plus" @click="showDialog = true" plain>Add station</el-button>
      </div>
    </page-header>

    <el-row :gutter="20" class="body-padding mobile-padding">
      <el-col :span="24">
        <el-table :data="stations" @cell-click="gotoStation">
          <el-table-column
            v-if="$screen.desktop"
            label="-"
            width="50">
            <template slot-scope="scope">
              <station-controls :station="scope.row" @remove="stations.splice(stations.indexOf($event), 1)" leftControl />
            </template>
          </el-table-column>
          <el-table-column  label="Name" prop="name" />
          <el-table-column v-if="$screen.desktop" width="150" label="Reference ID" prop="refId" />
          <el-table-column v-if="$screen.desktop" label="Organization" prop="organization.name" />
          <el-table-column v-if="$screen.desktop" width="400" label="Address">
            <template slot-scope="scope">
              {{ scope.row.address + ' - ' + scope.row.city + ' ' + scope.row.zip + ' - ' + scope.row.organization.country.name }}
            </template>
          </el-table-column>
          <el-table-column v-if="$screen.desktop" width="160" label="Gas quality">
            <template slot-scope="scope">
              <certification-status-badge
                v-if="scope.row.gasQualityStatus !== undefined && scope.row.gasQualityStatus !== null"
                :status="scope.row.gasQualityStatus" />
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            width="90">
              <template slot-scope="scope">
                <station-controls :station="scope.row" @update="updateStation" />
              </template>
            </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog :append-to-body="true" append-to-body width="800px" top="2vh" custom-class="dialog-no-padding" :visible.sync="showDialog">
      <upsert-form v-if="showDialog" @created="addStation" />
    </el-dialog>

  </div>
</template>

<script>
import UpsertForm from './../UpsertForm'
import StationControls from './StationControls'
import CertificationStatusBadge from './../station/Certification/CertificationStatusBadge'

export default {
  components: { UpsertForm, StationControls, CertificationStatusBadge },
  data () {
    return {
      loading: true,
      showDialog: false,
      stations: []
    }
  },
  methods: {
    addStation (station) {
      this.stations.unshift(station)
      this.showDialog = false
    },
    updateStation (station, updated) {
      const index = this.stations.indexOf(station)
      this.stations[index].currency = updated.currency
      this.stations[index].organization = updated.organization

      for (let key in updated) {
        this.stations[index][key] = updated[key]
      }
    },
    gotoStation (row, column, cell, event) {
      if (column.label) {
        this.$router.push({ name: 'Station', params: { sId: row.id }})
      }
    },
    async getStations () {
      const response = await this.$http.get(this.$api.stations.index)
      this.stations = response.data
      this.loading = false
    }
  },
  created () {
    this.getStations()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/system/SystemStations.vue